<template>
  <div
    v-if="getIsClient() && (isLoading || (!content.length && status === 'idle'))"
    class="flex flex-col"
  >
    <LcSkeleton height="1.875rem" radius="medium" width="60%" />
    <LcSkeleton class="mt-200 mb-100" height="1.625rem" radius="medium" width="40%" />
    <LcSkeleton class="mb-050" height="0.75rem" radius="medium" />
    <LcSkeleton class="mb-050" height="0.75rem" radius="medium" />
    <LcSkeleton class="mb-050" height="0.75rem" radius="medium" width="40%" />
  </div>
  <div v-else class="info-rules">
    <div v-if="content.length" :data-containerid="`${type}_informations`">
      <h2 class="headline-h3-headline">{{ title }}</h2>

      <template v-for="item in content" :key="item?.sys.id">
        <h3 v-if="item.caption" class="headline-h4-headline mt-200 mb-100">
          {{ item.caption }}
        </h3>

        <ContentfulRenderer class="content" :data="item.content" />
      </template>
    </div>
    <NoResults
      v-else
      :headline="$t('info.noresults.headline')"
      :subline="$t('info.noresults.subline')"
    />
  </div>
</template>

<script lang="ts" setup>
import type { ContentBlock } from '#content/shared/@types/generated/cms/graphql-schema-types'

import type { InfoPageProps } from '../types'

const { id, isVisible } = defineProps<InfoPageProps>()

const { data, execute, pending, status } = useContent().getRules(id, {
  immediate: false,
})
const isLoading = useMinimumLoading(pending)

const content = computed(() => (data.value?.contentBlocksCollection?.items as ContentBlock[]) || [])
const title = computed(() => data.value?.title)

watchImmediate(
  () => isVisible,
  async (newValue) => {
    if (!newValue || data.value) return
    await execute()
  },
)

onServerPrefetch(execute)
</script>

<style lang="scss" scoped>
.info-rules {
  :deep(.content) {
    h3,
    h4,
    h5,
    h6 {
      @include token-paragraph-bold;

      margin-bottom: token('size/space/gap/100');
    }

    dl,
    ol,
    ul {
      margin-bottom: token('size/space/gap/200');
    }

    ol,
    ul {
      padding-left: token('size/space/gap/200');
      list-style: unset;

      ::marker {
        color: token('color/text/accent/accent/placeholder');
      }
    }

    p {
      @include token-caption-regular;
    }
  }
}
</style>
